
import { Component, Vue } from 'vue-property-decorator';
import EditableCell from './component/editable-cell.vue';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  query: `${FCAPI}/boss/ruan/collocation`,
};
const OPTION_LIST = [
  {
    title: '搭配',
    dataIndex: 'name',
    width: '30%',
    align: 'center',
    slots: 'name',
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '子搭配名称',
    dataIndex: 'sub',
    align: 'center',
    slots: 'tags',
    scopedSlots: { customRender: 'tags' },
  },
];

@Component({
  components: {
    EditableCell,
  },
})
export default class Collocation extends Vue {
  is_loading = false;
  columns = OPTION_LIST;
  data_source = [];
  input_visible = false;
  input_value = '';
  add_row_id = 0;
  is_add = false;
  page = 1;
  click_tag_id: any = null;
  edit_value = '';
  created() {
    this.query();
  }

  // 新添加搭配
  async handleAdd() {
    (this.data_source as any) = [
      ...this.data_source,
      { name: ' ', parent_id: 0, id: Math.random(), new_flag: true },
    ];
  }
  // 查询列表
  async query(page = 1) {
    this.is_loading = true;
    this.page = page;
    const { data } = await this.$axios.get(API.query, {
      params: { current: this.page },
    });
    if (data.status !== 200) return;
    this.data_source = data.data;
    this.is_loading = false;
  }
  // 新增
  async add(params: any) {
    const { data } = await this.$axios.post(API.query, { ...params });
    return data;
  }
  // 添加标签展示输入框
  showInput(id: number) {
    this.input_visible = true;
    this.add_row_id = id;
    this.$nextTick(function () {
      (this.$refs.input as any).focus();
    });
  }
  // 添加标签输入确定
  async handleInputConfirm(addTag: any) {
    if (!this.input_value) {
      this.input_visible = false;
      return;
    }
    const data = await this.add({
      parent_id: addTag.id,
      name: this.input_value,
    });
    this.input_visible = false;
    this.input_value = '';
    if (data.status !== 200) {
      this.$message.error(data.message);
      return;
    }
    this.query();
    this.$message.success('添加成功');
  }
  // 编辑标签
  handleEdit(tag: any) {
    this.click_tag_id = tag.id;
    this.edit_value = tag.name;
  }
  // 提交编辑结果
  async handleEditConfirm(tag: any, record: any) {
    if (!this.edit_value) {
      return this.$message.error('请填写标签名称');
    }
    const { data } = await this.$axios.put(`${API.query}/${record.id}`, {
      id: tag.id,
      name: this.edit_value,
    });
    if (data.status !== 200) {
      this.$message.error(data.message);
      return;
    }
    this.click_tag_id = null;
    this.edit_value = '';
    this.query();
    this.$message.success('编辑成功');
  }
  // 修改搭配名称
  async onCellChange(record: any) {
    if (record.new_flag) {
      const data = await this.add({ name: record.name, parent_id: 0 });
      if (data.status !== 200) {
        this.$message.error(data.message);
        return;
      }
      return this.$message.success('添加成功');
    }
    const { data } = await this.$axios.put(`${API.query}/${record.id}`, {
      id: record.id,
      name: record.name,
    });
    if (data.status !== 200) {
      this.$message.error(data.message);
      return;
    }
    this.query();
    this.$message.success('编辑成功');
  }
}
